var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.805 2.19673C17.545 1.93573 17.123 1.93573 16.862 2.19673L10 9.05873L3.13801 2.19673C2.878 1.93573 2.45599 1.93573 2.19499 2.19673C1.93501 2.45672 1.93501 2.87874 2.19499 3.13873L9.05799 10.0007L2.19499 16.8627C1.93501 17.1237 1.93501 17.5457 2.19499 17.8057C2.45601 18.0657 2.878 18.0657 3.13801 17.8057L10 10.9437L16.862 17.8057C17.123 18.0657 17.545 18.0657 17.805 17.8057C18.065 17.5457 18.065 17.1237 17.805 16.8627L10.943 10.0007L17.805 3.13873C18.065 2.87874 18.065 2.45672 17.805 2.19673Z",
    fill: "#737188"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.944ea78b9382399a8cd4cc0250b3a50f.svg";
export { ForwardRef as ReactComponent };